export const getOrderPlaybackConfig = (
  config?: Record<string, number>,
): OrderPlaybackConfig => {
  const locationFadeIn = config?.locationFadeIn ?? 1000;
  const timeFadeIn = config?.timeFadeIn ?? 2000;
  const orderDetailsFadeIn = config?.orderDetailsFadeIn ?? 3000;
  const lineItemsFadeIn = config?.lineItemsFadeIn ?? 4000;
  const confirmationFadeIn = config?.confirmationFadeIn ?? 8000;
  const orderSubmissionDelay = lineItemsFadeIn + confirmationFadeIn;

  return {
    locationFadeIn,
    timeFadeIn,
    orderDetailsFadeIn,
    lineItemsFadeIn,
    confirmationFadeIn,
    orderSubmissionDelay,
  };
};

type OrderPlaybackConfig = {
  locationFadeIn: number;
  timeFadeIn: number;
  orderDetailsFadeIn: number;
  lineItemsFadeIn: number;
  confirmationFadeIn: number;
  orderSubmissionDelay: number;
};
